/**
 * Application-wide configuration constants
 */

/**
 * Polling configuration for auto-refresh intervals
 */
export const POLLING_CONFIG = {
  /** Refresh interval for active connections (10 seconds) */
  CONNECTIONS_REFRESH_INTERVAL: 10000,

  /** Slower refresh interval when tab is hidden (30 seconds) */
  CONNECTIONS_REFRESH_INTERVAL_SLOW: 30000,
} as const;

/**
 * API configuration
 */
export const API_CONFIG = {
  /** Default timeout for API requests (milliseconds) */
  DEFAULT_TIMEOUT: 30000,
} as const;

/**
 * UI configuration
 */
export const UI_CONFIG = {
  /** Toast notification duration (milliseconds) */
  TOAST_DURATION: 3000,

  /** Debounce delay for search inputs (milliseconds) */
  SEARCH_DEBOUNCE: 300,
} as const;
